"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _NormalButton = _interopRequireDefault(require("./NormalButton"));

var ColoredAccentButton = function ColoredAccentButton(props) {
  var status = props.status;
  var statusColors = {
    normal: 'accent',
    danger: 'red',
    success: 'green',
    warning: 'yellow'
  };
  var statusColor = statusColors[status];
  var hoverStatusColor = statusColors[status] + 'Hover';
  var activeStatusColor = statusColors[status] + 'Clicked';
  return _react.default.createElement(_NormalButton.default, (0, _extends2.default)({}, props, {
    textColorName: statusColor,
    iconFillName: statusColor,
    hoverTextColorName: hoverStatusColor,
    hoverIconFillName: hoverStatusColor,
    clickedTextColorName: activeStatusColor,
    clickedIconFillName: activeStatusColor
  }));
};

ColoredAccentButton.propTypes = _NormalButton.default.propTypes;
var _default = ColoredAccentButton;
exports.default = _default;